<template>
  <div class="my-card">
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end mb-2">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <!-- kalau row header kategori -->
        <span v-if="props.row.isHeader">
          <span
            v-if="props.column.field === 'name'"
            class="font-weight-bold text-uppercase p-1 w-100 d-block"
          >
            {{ props.row.category }}
          </span>
          <span v-else>-</span>
        </span>

        <!-- kalau row data normal -->
        <span v-else>
          <span v-if="props.column.field === 'debit' || props.column.field === 'credit' || props.column.field === 'balance'">
            {{ new Intl.NumberFormat('en-US').format(props.formattedRow[props.column.field]) }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="[3,5,10]"
              class="mx-1"
              @input="value => props.perPageChanged({ currentPerPage: value })"
            />
            <span class="text-nowrap">
              of {{ props.total }} entries
            </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="value => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>

            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        { field: 'coa', label: 'Kode COA' },
        { field: 'name', label: 'Nama COA' },
        { field: 'debit', label: 'Debit', type: 'number' }, // saldo ditambah
        { field: 'credit', label: 'Kredit', type: 'number' }, // saldo ditambah
        { field: 'balance', label: 'Saldo', type: 'number' }, // saldo ditambah
      ],
      rows: [],
      searchTerm: '',
      total_balance: 0,
    }
  },
  computed: {
    direction() {
      return store.state.appConfig.isRTL
    },
  },
  created() {
    this.$http.get('/coa/balancesheet')
      .then(res => {
        const sections = res.data.data
        const rows = []

        Object.keys(sections).forEach(section => {
        // tambahin row header kategori
          rows.push({
            isHeader: true,
            category: section.toUpperCase(),
          })

          Object.values(sections[section]).forEach(acc => {
            const totalBalance = (acc.total_debit ?? 0) - (acc.total_credit ?? 0)

            rows.push({
              uuid: acc.id,
              coa: acc.coa,
              name: acc.name,
              debit: acc.total_debit ?? 0,
              credit: acc.total_credit ?? 0,
              balance: totalBalance ?? 0,
              category: acc.category?.name || section.toUpperCase(),
              isHeader: false,
            })
          })
        })

        this.rows = rows
      })
      .catch(err => {
        console.error('Gagal ambil data balance sheet:', err)
      })
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
